import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ArrowIconSvg = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.53366 7.33925L0.193175 1.99874C-0.0643917 1.74117 -0.0643917 1.32359 0.193175 1.06605L0.816057 0.443169C1.07318 0.186042 1.48991 0.185547 1.74765 0.442069L6.00001 4.67452L10.2524 0.442069C10.5101 0.185547 10.9268 0.186042 11.1839 0.443169L11.8068 1.06605C12.0644 1.32362 12.0644 1.7412 11.8068 1.99874L6.46637 7.33925C6.2088 7.59679 5.79122 7.59679 5.53366 7.33925Z\" fill=\"#676F76\"/>\n</svg>\n";

var DisabledArrowIconSvg = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.53366 7.33925L0.193175 1.99874C-0.0643917 1.74117 -0.0643917 1.32359 0.193175 1.06605L0.816057 0.443169C1.07318 0.186042 1.48991 0.185547 1.74765 0.442069L6.00001 4.67452L10.2524 0.442069C10.5101 0.185547 10.9268 0.186042 11.1839 0.443169L11.8068 1.06605C12.0644 1.32362 12.0644 1.7412 11.8068 1.99874L6.46637 7.33925C6.2088 7.59679 5.79122 7.59679 5.53366 7.33925Z\" fill=\"#D0D6DA\"/>\n</svg>\n";

var TwArrowIconSvg = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.53366 7.33925L0.193175 1.99874C-0.0643917 1.74117 -0.0643917 1.32359 0.193175 1.06605L0.816057 0.443169C1.07318 0.186042 1.48991 0.185547 1.74765 0.442069L6.00001 4.67452L10.2524 0.442069C10.5101 0.185547 10.9268 0.186042 11.1839 0.443169L11.8068 1.06605C12.0644 1.32362 12.0644 1.7412 11.8068 1.99874L6.46637 7.33925C6.2088 7.59679 5.79122 7.59679 5.53366 7.33925Z\" fill=\"#95999A\"/>\n</svg>\n";

var ArrowIcon = window.btoa(ArrowIconSvg);
var DisabledArrowIcon = window.btoa(DisabledArrowIconSvg);
var TwArrowIcon = window.btoa(TwArrowIconSvg);
var Select = function Select(_a) {
  var _b = _a.appearance,
    appearance = _b === void 0 ? "default" : _b,
    disabled = _a.disabled,
    _c = _a.size,
    size = _c === void 0 ? "sm" : _c,
    options = _a.options,
    _d = _a.selectedValue,
    selectedValue = _d === void 0 ? "" : _d,
    _e = _a.invalid,
    invalid = _e === void 0 ? false : _e,
    otherProps = __rest(_a, ["appearance", "disabled", "size", "options", "selectedValue", "invalid"]);
  var selectCssClasses = classNames(["rounded-base", "appearance-none", "pl-md", "w-full", "overflow-hidden", "inline-block", "border", "focus:outline-none", "h-3xl tw:h-5xl", getTextClasses(size, disabled), getBorderClasses(appearance, invalid, disabled), getCursorClasses(disabled), getBackgroundClasses(disabled), getIconClasses()]);
  return /*#__PURE__*/React.createElement("select", __assign({
    className: selectCssClasses,
    disabled: disabled,
    defaultValue: selectedValue,
    style: getSelectInlineStyles(disabled)
  }, otherProps), renderSelectBody(options));
};
function renderSelectBody(options) {
  return options.map(function (option) {
    if (Array.isArray(option)) {
      return /*#__PURE__*/React.createElement("optgroup", {
        key: option[0],
        label: option[0]
      }, renderSelectOptions(option[1]));
    } else {
      return renderSingleOption(option);
    }
  });
}
function renderSelectOptions(options) {
  return options.map(function (option) {
    return renderSingleOption(option);
  });
}
function renderSingleOption(option) {
  var optionCssClasses = "tw:hover:bg-tw-neutral-100";
  return /*#__PURE__*/React.createElement("option", {
    key: option.value,
    value: option.value,
    disabled: option.disabled,
    className: optionCssClasses
  }, option.label);
}
function getBorderClasses(appearance, invalid, disabled) {
  if (invalid) {
    return "border-danger tw:border-2 tw:border-tw-danger-500";
  }
  if (appearance === "minimal") {
    return "border-transparent";
  }
  if (disabled) {
    return "border-muted tw:border-tw-neutral-200";
  }
  return classNames(["border-muted tw:border-tw-neutral-200", "hover:border-secondary tw:hover:border-tw-neutral-500", "focus:border-body tw:focus:border-tw-primary-500 tw:focus:ring-1 tw:focus:ring-tw-primary-500"]);
}
function getTextClasses(size, disabled) {
  return [{
    "text-xs tw:text-base": size === "sm"
  }, {
    "text-sm tw:text-lg": size === "md"
  }, {
    "text-secondary tw:text-tw-secondary-800": !disabled
  }, {
    "text-muted tw:text-tw-neutral-500": disabled
  }, "tw:leading-150"];
}
function getCursorClasses(disabled) {
  return disabled ? "cursor-not-allowed" : "cursor-pointer";
}
function getSelectInlineStyles(disabled) {
  var icon = disabled ? DisabledArrowIcon : ArrowIcon;
  return {
    "--arrow-icon-url": "url('data:image/svg+xml;base64,".concat(icon, "')"),
    "--tw-arrow-icon-url": "url('data:image/svg+xml;base64,".concat(TwArrowIcon, "')")
  };
}
function getIconClasses() {
  return ["bg-[image:var(--arrow-icon-url)] tw:bg-[image:var(-tw-arrow-icon-url)]", "bg-no-repeat", "bg-[top_0.75rem_right_0.5rem] tw:bg-[top_1.25rem_right_0.75rem]", "bg-[length:0.75rem_0.5rem]", "pr-[1.75rem] tw:pr-[2.25rem]"];
}
function getBackgroundClasses(disabled) {
  if (disabled) {
    return "bg-lightest tw:bg-tw-neutral-100";
  }
  return "bg-lightest tw:bg-white";
}
Select.propTypes = {
  appearance: PropTypes.oneOf(["default", "minimal"]),
  size: PropTypes.oneOf(["sm", "md"]),
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  }), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  }))]))]).isRequired),
  selectedValue: PropTypes.string,
  invalid: PropTypes.bool
};

export { Select };
//# sourceMappingURL=index.es.js.map
